import { useClerk, useUser } from "@clerk/clerk-react";
import { C, FONT_STACK } from "../constants/colors";
import BrillLogo from "./BrillLogo";

// Shown when someone is signed in but has not been granted Brill access
// (no publicMetadata.phase). Points them to the request-access form.

const REQUEST_ACCESS_URL = "https://info.tevrawood.com/masterclass-brill-access";

export function NoAccessScreen() {
  const { signOut } = useClerk();
  const { user } = useUser();
  const email = user?.primaryEmailAddress?.emailAddress;

  return (
    <div style={{
      minHeight: "100vh", background: C.indigo,
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      padding: "20px", fontFamily: FONT_STACK,
    }}>
      <div style={{ textAlign: "center", width: "100%", maxWidth: 420 }}>
        <BrillLogo height={72} style={{ margin: "0 auto 24px" }} />

        <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 20px 60px rgba(0,0,0,0.3)", padding: "28px 24px" }}>
          <h2 style={{ margin: "0 0 10px", fontSize: 18, fontWeight: 700, color: C.indigo }}>Access not active yet</h2>
          <p style={{ margin: "0 0 20px", fontSize: 14, color: "#666", lineHeight: 1.55 }}>
            You're signed in{email ? <> as <strong style={{ color: C.indigo }}>{email}</strong></> : ""}, but this account doesn't have Brill access yet. Request access below and we'll get you set up.
          </p>
          <a
            href={REQUEST_ACCESS_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "block", background: C.teal, color: "#fff", textDecoration: "none",
              borderRadius: 10, padding: "12px 16px", fontSize: 15, fontWeight: 600,
            }}
          >
            Request access to Brill
          </a>
        </div>

        <button
          onClick={() => signOut()}
          style={{
            marginTop: 18, background: "none", border: "none",
            color: "#888", fontSize: 13, cursor: "pointer", textDecoration: "underline",
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
